import {NgModule} from '@angular/core';
import {Routes, RouterModule} from '@angular/router';
import {CoachProfilesPage} from './coach-profiles/coach-profiles.page';
import {CoachProfilePage} from './coach-profile/coach-profile.page';
import {CoachCalendarPage} from './coach-calendar/coach-calendar.page';
import {CoachAppointmentsPage} from './coach-appointments/coach-appointments.page';
import {CoachRequestsIncomingPage} from './coach-requests-incoming/coach-requests-incoming.page';
import {CoachAvailabilityPage} from './coach-availability/coach-availability.page';
import {CoachJourneyPage} from './coach-journey/coach-journey.page';
import {CoachFeedbackPage} from './coach-feedback/coach-feedback.page';

const routes: Routes = [
    {
        path: 'profiles',
        component: CoachProfilesPage
    },
    {
        path: 'profile/:coachId',
        component: CoachProfilePage,
        data: { level: 'manager' }
    },
    {
        path: 'profile/:coachId/calendar',
        component: CoachCalendarPage,
        data: { level: 'manager' }
    },
    {
        path: 'profile/:coachId/calendar/:titleId',
        component: CoachCalendarPage,
        data: { level: 'manager' }
    },
    {
        path: 'appointments',
        component: CoachAppointmentsPage,
        data: { level: 'manager' }
    },
    {
        path: 'requests-incoming',
        component: CoachRequestsIncomingPage,
        data: { level: 'manager' }
    },
    {
        path: 'availability',
        component: CoachAvailabilityPage,
        data: { level: 'manager' }
    },
    {
        path: 'journey',
        component: CoachJourneyPage,
        data: { level: 'learner' }
    },
    {
        path: 'journey/profile/:delegateId',
        component: CoachJourneyPage,
        data: { level: 'manager' }
    },
    {
        path: 'journey/details/:delegateId',
        component: CoachJourneyPage,
        data: { level: 'coach' }
    },
    {
        path: 'feedback/:sessionId',
        component: CoachFeedbackPage,
        data: { level: 'learner' }
    },
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule],
})
export class CoachRoutingModule {
}
